import { PayloadAction } from '@reduxjs/toolkit';
import { DesignState } from 'src/store/design/types';

const setDesignInternalUidReducer = (state: DesignState, action: PayloadAction<string | undefined>) => {
  state.internalUid = action.payload;
};

export default setDesignInternalUidReducer;
